<template>
    <div class="af-search-container afu-bg-custom-searchbarbg">
        <div class="af-search-results-container afu-w-full afu-max-w-screen-xl afu-ml-auto afu-mr-auto afu-px-4 afu-box-border">
            <SearchBarMobile @search="onSearch" />
            <FilterTagsList @search="onSearch" />
        </div>
        <div class="afu-bg-white">
            <div class="af-search-results-container afu-bg-white afu-w-full afu-max-w-screen-xl afu-ml-auto afu-mr-auto afu-px-4 afu-box-border">
                <hr class="afu-border afu-border-custom-divider afu-mb-6">
                <div class="afu-flex afu-flex-wrap">
                    <div class="afu-w-full">
                        <div
                            v-if="$_search.searchPayload.meta"
                            class="af-search-title"
                        >
                            <h1 class="afu-mb-4 afu-text-sm afu-text-center">
                                {{ $_search.searchPayload.meta.title }}
                            </h1>
                            <C1Alert
                                v-if="$_search.searchPayload.warning_message"
                                variant="danger"
                            >
                                <span v-html="$_search.searchPayload.warning_message" />
                            </C1Alert>
                        </div>
                        <div class="af-save-search-mobile afu-my-4">
                            <SaveSearch :has-jobs="$_jobsCount > 0" />
                        </div>
                        <div class="af-search-header afu-flex afu-items-center afu-justify-between afu-my-6">
                            <div 
                                class="af-search-info afu-w-2/3"
                                v-if="$_jobsCount"
                            >
                                <template v-if="!$_search.loading.jobs">
                                    <C1PaginatorShowingResults
                                        :map-view="mapView"
                                        :per-page="paginator.per_page"
                                        :current-page="$_jobsSearchFilters.page"
                                        :total="mapView ? $_mapViewJobsCount : $_jobsCount"
                                    />
                                </template>
                            </div>
                            <div
                                v-if="!$_search.loading.jobs"
                                class="af-search-actions afu-flex"
                            >
                                <SearchViewBtn
                                    v-if="isMapEnabled && $_jobsCount > 0"
                                    size="md"
                                    class="afu-mr-4"
                                    :view="mapView ? 'map' : 'list'"
                                    @click="toggleMapView"
                                />
                                <SortSearch v-if="!mapView && $_jobsCount > 0" />
                            </div>
                        </div>
                        <template v-if="$_search.loading.jobs">
                            <template v-if="mapView">
                                <div class="afu-bg-white afu-rounded-2xl afu-shadow-lg afu-text-center afu-py-48 afu-animate-pulse">
                                    <FontAwesomeIcon
                                        :icon="['far', 'map-marked']"
                                        class="afu-text-neutral--light"
                                        size="3x"
                                    />
                                </div>
                            </template>
                            <template v-else>
                                <div class="af-search-result-item-mobile afu-mb-4 afu-border afu-border-solid afu-rounded-secondary afu-border-neutral afu-bg-white hover:afu-shadow-card afu-transition afu-duration-300 hover:afu-border-none afu-group afu-relative">
                                    <div class="afu-flex afu-flex-col afu-flex-1 afu-gap-5 afu-sm:p-2">
                                        <div class="afu-flex afu-p-5 md:afu-p-6 afu-flex-1 afu-flex-col afu-gap-3">
                                            <div class="afu-bg-gray-200 afu-w-full afu-animate-pulse afu-h-10 afu-rounded-2xl" />
                                            <div class="afu-bg-gray-200 afu-w-full afu-animate-pulse afu-h-3 afu-rounded-2xl" />
                                            <div class="afu-bg-gray-200 afu-w-full afu-animate-pulse afu-h-3 afu-rounded-2xl" />
                                            <div class="afu-bg-gray-200 afu-w-full afu-animate-pulse afu-h-3 afu-rounded-2xl" />
                                        </div>
                                        <div class="afu-bg-gray-100 afu-mt-auto afu-px-6 md:afu-mt-2 afu-py-3 afu-flex afu-gap-3">
                                            <div class="afu-bg-gray-200 afu-w-full afu-h-8 afu-animate-pulse afu-rounded-full" />
                                            <div class="afu-bg-gray-200 afu-w-20 afu-h-8 afu-animate-pulse afu-rounded-full afu-ml-auto" />
                                        </div>
                                    </div>
                                </div>
                                <div class="af-search-result-item-mobile afu-mb-4 afu-border afu-border-solid afu-rounded-secondary afu-border-neutral afu-bg-white hover:afu-shadow-card afu-transition afu-duration-300 hover:afu-border-none afu-group afu-relative">
                                    <div class="afu-flex afu-flex-col afu-flex-1 afu-gap-5 afu-sm:p-2">
                                        <div class="afu-flex afu-p-5 md:afu-p-6 afu-flex-1 afu-flex-col afu-gap-3">
                                            <div class="afu-bg-gray-200 afu-w-full afu-animate-pulse afu-h-10 afu-rounded-2xl" />
                                            <div class="afu-bg-gray-200 afu-w-full afu-animate-pulse afu-h-3 afu-rounded-2xl" />
                                            <div class="afu-bg-gray-200 afu-w-full afu-animate-pulse afu-h-3 afu-rounded-2xl" />
                                            <div class="afu-bg-gray-200 afu-w-full afu-animate-pulse afu-h-3 afu-rounded-2xl" />
                                        </div>
                                        <div class="afu-bg-gray-100 afu-mt-auto afu-px-6 md:afu-mt-2 afu-py-3 afu-flex afu-gap-3">
                                            <div class="afu-bg-gray-200 afu-w-full afu-h-8 afu-animate-pulse afu-rounded-full" />
                                            <div class="afu-bg-gray-200 afu-w-20 afu-h-8 afu-animate-pulse afu-rounded-full afu-ml-auto" />
                                        </div>
                                    </div>
                                </div>
                                <div class="af-search-result-item-mobile afu-mb-4 afu-border afu-border-solid afu-rounded-secondary afu-border-neutral afu-bg-white hover:afu-shadow-card afu-transition afu-duration-300 hover:afu-border-none afu-group afu-relative">
                                    <div class="afu-flex afu-flex-col afu-flex-1 afu-gap-5 afu-sm:p-2">
                                        <div class="afu-flex afu-p-5 md:afu-p-6 afu-flex-1 afu-flex-col afu-gap-3">
                                            <div class="afu-bg-gray-200 afu-w-full afu-animate-pulse afu-h-10 afu-rounded-2xl" />
                                            <div class="afu-bg-gray-200 afu-w-full afu-animate-pulse afu-h-3 afu-rounded-2xl" />
                                            <div class="afu-bg-gray-200 afu-w-full afu-animate-pulse afu-h-3 afu-rounded-2xl" />
                                            <div class="afu-bg-gray-200 afu-w-full afu-animate-pulse afu-h-3 afu-rounded-2xl" />
                                        </div>
                                        <div class="afu-bg-gray-100 afu-mt-auto afu-px-6 md:afu-mt-2 afu-py-3 afu-flex afu-gap-3">
                                            <div class="afu-bg-gray-200 afu-w-full afu-h-8 afu-animate-pulse afu-rounded-full" />
                                            <div class="afu-bg-gray-200 afu-w-20 afu-h-8 afu-animate-pulse afu-rounded-full afu-ml-auto" />
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </template>
                        <template v-else>
                            <SearchResultMap
                                :jobs="$_jobs"
                                v-if="mapView"
                            />
                            <SearchResultLoop
                                :jobs="$_jobs"
                                v-else
                            />
                            <template
                                v-if="!mapView && $_jobsCount > paginator.per_page"
                            >
                                <C1Paginator
                                    :current-page="$_jobsSearchFilters.page"
                                    :total="$_jobsCount"
                                    :per-page="paginator.per_page"
                                    @change="changePage"
                                />
                            </template>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SearchMixin from './Mixins/SearchMixin';

    export default {
        name: 'SearchResultsMobile',

        mixins: [SearchMixin],

        data() {
            return {

            };
        },
    };
</script>

<style>

    .af-search-result-item-mobile .v-skeleton-loader__actions {
        text-align: left;
    }

    .af-search-result-item-mobile .v-skeleton-loader__button {
        border-radius: 0;
        height: 38px;
        width: 116px;
        margin: 0 10px 0 0;
    }

</style>
